import type { Calendar } from 'owa-calendar-cache';
import { getStore } from '../store/store';

export function isSelectedCalendar(calendar: Calendar): boolean {
    // Check if the calendar id is among the selected calendars. We don't check the object
    // equivalence as it can be replaced with a new object of same id in some scenarios e.g. renaming
    return (
        getStore()
            .selectedCalendars.map(cal => cal.id.id)
            .indexOf(calendar.id.id) !== -1
    );
}
